import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
// @ts-ignore
import { ACTUAL_THEMES_ROOT_ID } from '@yandex-int/k-common/constants';
import { Theme, ThemeDetails } from '@yandex-int/k-common/typings';
// @ts-ignore
import { getActualThemeId } from '@yandex-int/k-common/utils/get-actual-theme-id';
import b from 'b_';
import get from 'lodash/get';
import { MarkdownExtXContent, Spin, Text } from 'platform-components';
import { Route, Switch, Redirect } from 'platform-components/src/components/router/router';
import { SUBJECTS_SLUGS_TYPE } from 'platform-components/src/typings';
import { withRouterPath, InjectedProps as WithRouterPathHOC } from 'platform-components/hocs';
import { reportMessage } from 'platform-components/utils';
import PropTypes from 'prop-types';
import qs from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { matchPath } from 'react-router-dom';
import { bindActionCreators, compose, Dispatch } from 'redux';

import { getCurrentClass, getTeamGrade } from 'common.components/user/selectors';
import { isPrimarySchool as isPrimarySchoolUtil } from 'common.components/user/utils';
import * as themesActions from 'store/themes/actions';
import * as themesSelectors from 'store/themes/selectors';

import { RootAction, ReduxTeacherStore } from '../../typings';
import * as libraryActions from '../library.store/actions';
import { getIsThemeEmpty, getThemeDetails } from '../library.store/selectors';

import Menu from './__menu/theme-page__menu';
import PrepLessons from './__prep-lessons/theme-page__prep-lessons';
import Stacks from './__stacks/theme-page__stacks';
import { DisplayOptions } from './typings';

import './theme-page.scss';

interface StoreProps {
    canViewParentThemes: boolean;
    teamGrade: number | null;
    isThemeEmpty: boolean;
    parent: Theme | null;
    parentThemeId: number;
    subject: SUBJECTS_SLUGS_TYPE;
    theme: Theme | undefined;
    themeDetails: ThemeDetails | null;
    themeId: number;
    themes: Array<Theme>;
    isPrimarySchool: boolean;

    // для актуальных тем
    themesLoadingStatus: LOADING_STATUSES;
    isActualTheme: boolean;
}

interface DispatchProps {
    getThemeInfoRequest: typeof libraryActions.getThemeDetailsRequest;
    setThemesTreeLoadingStatus: typeof themesActions.setThemesTreeLoadingStatus;
}

interface OwnProps extends WithRouterPathHOC {}

interface Props extends OwnProps, StoreProps, DispatchProps {}

export class ThemePage extends React.PureComponent<Props> {
    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };

    componentDidMount() {
        const { getThemeInfoRequest, themeId, themeDetails } = this.props;

        if (themeId && !themeDetails) {
            getThemeInfoRequest(themeId);
        }
    }

    componentDidUpdate(prevProps: Props): void {
        const { themeId: prevThemeId } = prevProps;
        const { getThemeInfoRequest, themeDetails, themeId, teamGrade } = this.props;
        const themeIsChanged = themeId !== prevThemeId;
        const gradeIsChanged = teamGrade !== prevProps.teamGrade;

        if (gradeIsChanged || (themeIsChanged && !themeDetails)) {
            getThemeInfoRequest(themeId);
        }
    }
    context!: React.ContextType<React.Context<{ staticUrls: Record<string, string> }>>;

    getTabsCount = (): { lessonsCount: number; stacksCount: number } => {
        const { themeDetails } = this.props;

        return {
            lessonsCount: get(themeDetails, 'lessons_count', 0),
            stacksCount: get(themeDetails, 'stacks_count', 0),
        };
    };

    // eslint-disable-next-line complexity
    getMenuRenderingOptions = (): DisplayOptions => {
        const { isThemeEmpty, canViewParentThemes, isPrimarySchool, parent, isActualTheme } = this.props;

        const { lessonsCount, stacksCount } = this.getTabsCount();
        const shouldShowStacksTab = stacksCount > 0;
        const lessonsAreNotEmpty = lessonsCount > 0;
        const shouldShowPrepLessonsTab = isPrimarySchool && lessonsAreNotEmpty;
        const shouldHideTabs =
            isThemeEmpty || (!canViewParentThemes && (!shouldShowStacksTab || !shouldShowPrepLessonsTab));
        const shouldShowSectionMenu = ((canViewParentThemes && Boolean(parent)) || isActualTheme) && !isThemeEmpty;

        return {
            shouldShowStacksTab,
            shouldHideTabs,
            shouldShowSectionMenu,
            shouldHideMenu: shouldHideTabs && !shouldShowSectionMenu,
            shouldShowTheme: !isThemeEmpty,
        };
    };

    // eslint-disable-next-line complexity
    getRedirectPath = (): string | null => {
        const {
            themeDetails,
            match: { path, params },
            isPrimarySchool,
        } = this.props;
        const { staticUrls } = this.context;

        const isThemePath = [staticUrls.labLibrarySubjectTheme, staticUrls.deepLabTheme].some((url) =>
            matchPath(path, { path: url, exact: true })
        );
        const isStacksPath = [staticUrls.labLibrarySubjectThemeStacks, staticUrls.deepLabStacks].some((url) =>
            matchPath(path, { path: url, exact: true })
        );
        const isLessonsPath = [staticUrls.labLibrarySubjectThemeLessons, staticUrls.deepLabThemeLessons].some((url) =>
            matchPath(path, { path: url, exact: true })
        );
        const lessonCount = get(themeDetails, 'lessons_count', 0);
        const stacksCount = get(themeDetails, 'stacks_count', 0);

        const isStacksPathWithNoStacks = isStacksPath && stacksCount === 0;
        const isLessonsPathWithNoLessons = isLessonsPath && lessonCount === 0;
        const isLessonsPathSecondarySchool = !isPrimarySchool && isLessonsPath;

        // редиректим с ГЗ на стопки, если ГЗ нет, а стопки есть
        // или если в 5ом классе, если есть стопки
        // + принудительный редирект с темы в ГЗ или стопки
        const shouldRedirectToStacksPath =
            stacksCount > 0 && (isLessonsPathWithNoLessons || isLessonsPathSecondarySchool || isThemePath);
        const shouldRedirectToLessonsPath = lessonCount > 0 && (isStacksPathWithNoStacks || isThemePath);

        if (themeDetails) {
            if (shouldRedirectToStacksPath) {
                return params?.classId ? staticUrls.labLibrarySubjectThemeStacks : staticUrls.deepLabStacks;
            }

            if (shouldRedirectToLessonsPath) {
                return params?.classId ? staticUrls.labLibrarySubjectThemeLessons : staticUrls.deepLabThemeLessons;
            }
        }

        return null;
    };

    // eslint-disable-next-line complexity
    render() {
        const {
            match: {
                params: { subject },
            },
            location: { search },
            themeId,
            theme,
            themes,
            canViewParentThemes,
            getRouterPath,
            themesLoadingStatus,
            isActualTheme,
            setThemesTreeLoadingStatus,
        } = this.props;
        const {
            staticUrls: {
                labLibrarySubjectThemeStacks,
                labLibrarySubjectThemeLessons,
                labLibrarySubject,
                deepLabStacks,
                deepLabThemeLessons,
            },
        } = this.context;

        if (!theme) {
            // редиректим с актуальных тем, если что-то пошло не так
            if (themesLoadingStatus === LOADING_STATUSES.ERROR && isActualTheme) {
                reportMessage(`Попытка зайти в несуществующую актуальную тему ${themeId + ACTUAL_THEMES_ROOT_ID}`);
                setThemesTreeLoadingStatus(subject, themeId, LOADING_STATUSES.UNSENT);
                return <Redirect to={getRouterPath(labLibrarySubject)} />;
            }

            return <Spin center />;
        }

        const redirectPath = this.getRedirectPath();

        if (redirectPath) {
            return <Redirect to={`${getRouterPath(redirectPath)}${search}`} />;
        }

        const closestParent = theme.parent ? themes.find(({ id }) => id === theme.parent) : null;
        const displayOptions = this.getMenuRenderingOptions();
        const { shouldHideMenu, shouldShowTheme } = displayOptions;

        return (
            <div className="theme-page">
                <div className="theme-page__parent-theme-title-wrapper">
                    {closestParent && canViewParentThemes && (
                        <div className="theme-page__parent-theme-title">
                            <Text size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN} weight={Text.WEIGHT.M}>
                                {closestParent.name}
                            </Text>
                        </div>
                    )}
                    <div className="theme-page__theme-title">
                        <Text size={Text.SIZE.XXXL} type={Text.TYPE.MARKDOWN} weight={Text.WEIGHT.M}>
                            {theme.name}
                        </Text>
                    </div>
                </div>
                {theme.description && (
                    <div className="theme-page__promo">
                        <Text>
                            <MarkdownExtXContent>{theme.description}</MarkdownExtXContent>
                        </Text>
                    </div>
                )}
                <Menu displayOptions={displayOptions} />
                {shouldShowTheme && (
                    <div className={b('theme-page', 'content', { 'menu-empty': shouldHideMenu })}>
                        <Switch>
                            <Route component={PrepLessons} exact key="libraryThemeRoute" path={deepLabThemeLessons} />
                            <Route
                                component={PrepLessons}
                                exact
                                key="libraryThemeRoute"
                                path={labLibrarySubjectThemeLessons}
                            />
                            <Route component={Stacks} exact key="libraryThemeRoute" path={deepLabStacks} />
                            <Route
                                component={Stacks}
                                exact
                                key="libraryThemeRoute"
                                path={labLibrarySubjectThemeStacks}
                            />
                        </Switch>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (
    storeState: ReduxTeacherStore,
    {
        location: { search },
        match: {
            params: { classId, subject, themeId: thId },
        },
    }: OwnProps
): StoreProps => {
    let themeId = Number(thId);
    const isActualTheme = themesSelectors.getIsActualTheme(storeState, { themeId });
    themeId = getActualThemeId(themeId);
    const currentTeam = getCurrentClass(storeState, { classId });
    const query = qs.parse(search);
    const grade = currentTeam?.level || Number(query.grade) || null;
    const themes: Array<Theme> = themesSelectors.getThemes(storeState, { subject, grade });
    const parentTheme = themesSelectors.getRootThemeByListTheme(storeState, { subject, themeId, grade });
    const parent = parentTheme ? parentTheme : null;

    return {
        subject,
        themeId,
        teamGrade: getTeamGrade(storeState, { classId }),
        isPrimarySchool: isPrimarySchoolUtil(grade),
        isThemeEmpty: getIsThemeEmpty(storeState, { themeId }),
        themes,
        theme: themesSelectors.getThemeById(storeState, { subject, themeId, grade }),
        themeDetails: getThemeDetails(storeState, { themeId }),
        parent,
        parentThemeId: Number(parentTheme?.id),
        canViewParentThemes: !parentTheme?.should_hide_child_themes,
        themesLoadingStatus: themesSelectors.getThemesTreeLoadingStatus(storeState, { subject, themeId, grade }),
        isActualTheme,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => {
    return bindActionCreators(
        {
            getThemeInfoRequest: libraryActions.getThemeDetailsRequest,
            setThemesTreeLoadingStatus: themesActions.setThemesTreeLoadingStatus,
        },
        dispatch
    );
};

export default compose<any>(withRouterPath, connect(mapStateToProps, mapDispatchToProps))(ThemePage);
